import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SettingsPage } from 'shared/components/settings/SettingsPage'
import { Features, useHasClientFeature } from 'shared/hooks/useHasClientFeature'

import { Email } from './Email'
import { Integrations } from './Integrations'
import { LoggedInDevices } from './LoggedInDevices'

export interface NotificationsProps {}

export const Notifications: FC<NotificationsProps> = () => {
    const { t } = useTranslation()

    const isIntegrationClientEnabled = useHasClientFeature(Features.integrations)

    return (
        <SettingsPage title={t('notifications.title')}>
            <LoggedInDevices />
            <Email />
            {isIntegrationClientEnabled && <Integrations />}
        </SettingsPage>
    )
}
